import Struct from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "./type.js";
export const ScrcpyInjectTextControlMessage = new Struct()
    .uint8("type", ScrcpyControlMessageType.InjectText)
    .uint32("length")
    .string("text", { lengthField: "length" });
//# sourceMappingURL=inject-text.js.map